import { MetricType } from '../../enum/metric-type.enum';

export interface IMetricDTO {
  identifier: string;
  name: string;
  createdAt: Date;
  updatedAt: Date;
  metricType: MetricType;
  isDivisible: boolean;
  isIdentifiable: boolean;
  allowNegative: boolean;
  maxIncrementValue: number;
  currentValue: number;
  values?: IMetricValueDTO[];
}

export interface IMetricValueDTO {
  value: number;
  tag: string;
  identifier: string;
}